import { create } from 'zustand';

type SessionSelectPlayerState = {
  /** Player ids selected on Select Player screen (session roster draft). */
  selectedIds: Set<string>;
  setSelectedIds: (ids: Iterable<string>) => void;
  toggleSelectedId: (playerId: string) => void;
  removeSelectedId: (playerId: string) => void;
  /** Clear all selections (e.g. logout). */
  reset: () => void;
};

const emptySet = () => new Set<string>();

export const useSessionSelectPlayerStore = create<SessionSelectPlayerState>((set, get) => ({
  selectedIds: emptySet(),

  setSelectedIds: (ids: Iterable<string>) => {
    set({ selectedIds: new Set(ids) });
  },

  toggleSelectedId: (playerId: string) => {
    const prev = get().selectedIds;
    const next = new Set(prev);
    if (next.has(playerId)) next.delete(playerId);
    else next.add(playerId);
    set({ selectedIds: next });
  },

  removeSelectedId: (playerId: string) => {
    const prev = get().selectedIds;
    if (!prev.has(playerId)) return;
    const next = new Set(prev);
    next.delete(playerId);
    set({ selectedIds: next });
  },

  reset: () => set({ selectedIds: emptySet() }),
}));
